module.exports = __webpack_public_path__ + "static/media/160.7c16740b.png";